"use client";
import cn from "clsx";
import { HTMLAttributes, useEffect, useLayoutEffect, useState } from "react";
import { Container, Box } from "@radix-ui/themes";
import SideItem, { IconLinkType } from "./sideItem";
import { SectionProps } from "@/components/common/interface/interfaces";
import { Debug } from "@/util/debug";
import { checkMobile } from "@/util/checkMobile";
import { AuthCRUD, AuthLayoutProps, PageAuth } from "../layoutType";
import { checkUserPageAuth, checkUsertypeCRUD } from "@/util/authutil";
export default function Side(props: SectionProps) {
  const menu = props.params?.menu?.group_list ?? [];
  const [isLoading, setIsLoading] = useState(props.params?.menu?.group_loading ?? true);
  const usertype = props.params?.user?.usertype;
  const sideAuth = props.params?.auth;
  useLayoutEffect(() => {
    setIsLoading(false);
  }, []);
  let size = 0;
  const menus = menu.map((item, index) => {
    // Debug("Side item", item, item.menu);
    if ((item.display ?? true) && checkUsertypeCRUD(usertype, item.list)) {
      // if (item.auth) {
      //   Debug("Side UserPageAuth", checkUserPageAuth(usertype, sideAuth, item, true));
      // }
      if (!item.auth || (item.auth && checkUserPageAuth(usertype, sideAuth, item, true).menu)) {
        size++;
        return (
          <SideItem
            key={"menu_" + index}
            link={item}
            showIcon={true}
            loading={isLoading}
            active={item.name === (props.params?.menu?.group_id ?? "")}
            props={props}
          />
        );
      }
    }
  });
  return (
    <nav className={cn(props.className, "main-menu screenAnimation", size > 0 ? "" : "hidden")}>
      <Container className="main-menu-container pr-8 md:pr-0 md:mx-2 lg:mx-4">
        <Box className="main-menu-box !flex lg:!block justify-between items-center">{menus}</Box>
      </Container>
    </nav>
  );
}
